// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3b999be7","239":"44528d93","453":"b90da1ea","827":"194cfae9"}[chunkId] + ".chunk.js";
};